var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{scopedSlots:_vm._u([{key:"side",fn:function(){return [_c('ButtonIcon',{attrs:{"hide-label-while-loading":"","to":{ name: 'SettlementsInvoicesCreate' }}},[_vm._v(" "+_vm._s(_vm.$t('add'))+" ")])]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.$t('invoices'))+" ")]),_c('Filters',{ref:"Filters"}),_c('Results',{ref:"Results"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }